import React, { useEffect, useState } from "react";
import db, { storage } from "./Firebase";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import Swal from "sweetalert2";

function WorkshopHindiVersion() {
    const [workshopList, setWorkshopList] = useState([]);
    const [selectedWorkshop, setSelectedWorkshop] = useState("");
    const [hindiName, setHindiName] = useState("");
    const [description, setDescription] = useState("");
    const [status, setStatus] = useState(true);
    const [imageFile, setImageFile] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [progress, setProgress] = useState(0);

    // Load workshop names once (desc order)
    useEffect(() => {
        const unsubscribe = db
            .collection("workshop_event_data")
            .orderBy("created_date", "desc")
            .onSnapshot((snapshot) => {
                setWorkshopList(
                    snapshot.docs.map((doc) => ({
                        id: doc.id,
                        name: doc.data()?.name || "",
                    }))
                );
            });
        return () => unsubscribe();
    }, []);

    // Upload image to Firebase Storage
    const uploadImage = async (file) => {
        return new Promise((resolve, reject) => {
            const fileName = `${Date.now()}_${file.name}`;
            const storageRef = ref(storage, `workshop_hindi_images/${fileName}`);
            const uploadTask = uploadBytesResumable(storageRef, file);

            uploadTask.on(
                "state_changed",
                (snapshot) => {
                    const progress =
                        (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    setProgress(progress);
                },
                (error) => {
                    console.error("Upload error:", error);
                    reject(error);
                },
                async () => {
                    const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
                    resolve(downloadURL);
                }
            );
        });
    };

    // Save new Hindi version entry
    const handleSave = async () => {
        if (!selectedWorkshop || !hindiName || !description) {
            Swal.fire("Please fill all required fields.", "", "error");
            return;
        }

        setUploading(true);
        try {
            let imageUrl = "";
            if (imageFile) {
                imageUrl = await uploadImage(imageFile);
            }

            await db.collection("workshop_hindi_version").add({
                workshop_name: selectedWorkshop,
                hindi_name: hindiName,
                description: description,
                status: status,
                image_url: imageUrl,
                created_date: new Date(),
            });

            Swal.fire("Saved!", "Hindi workshop version added successfully.", "success");
            setSelectedWorkshop("");
            setHindiName("");
            setDescription("");
            setImageFile(null);
            setProgress(0);
        } catch (error) {
            console.error("Error saving data:", error);
            Swal.fire("Error", "Failed to save data", "error");
        } finally {
            setUploading(false);
        }
    };

    return (
        <div className="container mt-4">
            <h4 className="mb-3 text-center">🪔 Add Hindi Workshop Version</h4>

            <div className="card p-3 shadow-sm">
                <div className="form-group mb-3">
                    <label>Select Workshop (from English list)</label>
                    <select
                        className="form-control"
                        value={selectedWorkshop}
                        onChange={(e) => setSelectedWorkshop(e.target.value)}
                    >
                        <option value="">-- Select Workshop --</option>
                        {workshopList.map((w) => (
                            <option key={w.id} value={w.name}>
                                {w.name}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="form-group mb-3">
                    <label>Hindi Name</label>
                    <input
                        type="text"
                        className="form-control"
                        value={hindiName}
                        onChange={(e) => setHindiName(e.target.value)}
                        placeholder="कार्यशाला का नाम दर्ज करें"
                    />
                </div>

                <div className="form-group mb-3">
                    <label>Hindi Description</label>
                    <textarea
                        className="form-control"
                        rows="5"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        placeholder="यहाँ विवरण लिखें..."
                    ></textarea>
                </div>



                <div className="form-check mb-3">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        checked={status}
                        onChange={(e) => setStatus(e.target.checked)}
                        id="statusCheck"
                    />
                    <label className="form-check-label" htmlFor="statusCheck">
                        Active
                    </label>
                </div>

                <button
                    onClick={handleSave}
                    className="btn btn-primary w-100"
                    disabled={uploading}
                >
                    {uploading ? "Saving..." : "Save Hindi Workshop"}
                </button>
            </div>
        </div>
    );
}

export default WorkshopHindiVersion;
